// @flow
import { injectGlobal } from 'styled-components';
import theme from './theme';

injectGlobal`

  body, html, #root, #root > div {
    height: 100%;
    position: relative;
    padding: 0;
    margin: 0;
    color: ${theme.colors.black};
    font-family: ${theme.fontBody};
  }
  * {
    box-sizing: border-box;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js